import SkeletonTable from "@/components/SkeletonTable";
import { useUser } from "@/hooks/useUser";
import { getListPesertaVerifikasiButawarna } from "@/services/getData";
import { useQuery } from "@tanstack/react-query";
import { AlertCircle, Eye } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import ValidationDashboard from "./partial/ValidationDasbhoard";

export default function VerifikasiPesertaButawarnaPage() {
  const [searchParams] = useSearchParams();
  const pageParams = searchParams.get("page") || "";
  const rowsPerPageParams = searchParams.get("rowsPerPage") || "";
  const searchQueryParams = searchParams.get("search") || "";
  const statusValidasiParams = searchParams.get("statusValidasi") || "";

  const { user } = useUser();
  const isVerifikatorAll = user?.jenis_user?.includes("verifikator_skl_all");
  const jenisVerifikatorParams = isVerifikatorAll ? 'all' : ""


  const { data, isPending, isError } = useQuery({
    queryKey: [
      "listPesertaVerifikasiButawarna",
      pageParams,
      rowsPerPageParams,
      searchQueryParams,
      statusValidasiParams,
      jenisVerifikatorParams,
    ],
    queryFn: () =>
      getListPesertaVerifikasiButawarna(
        pageParams as string,
        rowsPerPageParams as string,
        searchQueryParams as string,
        statusValidasiParams as string,
        jenisVerifikatorParams as string,
      ),
  });


  const { data: dataAll } = useQuery({
    queryKey: [
      "listPesertaVerifikasiButawarna",
    ],
    queryFn: () =>
      getListPesertaVerifikasiButawarna(
        undefined,
        "99999",
        undefined,
        undefined,
        jenisVerifikatorParams as string
      ),
  });

  return (
    <div className="flex flex-col h-full min-h-screen bg-background dark:bg-[#09090b] text-foreground p-4 md:p-6 transition-colors duration-200">
      <ValidationDashboard data={dataAll?.data} />
      {/* HEADER HALAMAN - Tetap tampil meski sedang loading */}
      <div className="mb-6 flex flex-col gap-1">
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 dark:text-slate-100 flex items-center gap-3">
          <div className="p-2.5 bg-primary/10 text-primary rounded-xl">
            {/* Ikon Eye (Mata) relevan dengan konteks tes Buta Warna */}
            <Eye className="w-6 h-6" />
          </div>
          Daftar Peserta Verifikasi Surat Keterangan Buta Warna
        </h1>
        <p className="text-sm text-muted-foreground max-w-2xl ml-1 sm:ml-[60px]">
          Tinjau, kelola, dan lakukan validasi terhadap dokumen Surat Keterangan
          Tidak Buta Warna yang diunggah oleh pendaftar.
        </p>
      </div>

      {/* AREA KONTEN (Tabel / Skeleton / Error) */}
      <div className="flex-1 w-full">
        {isPending ? (
          /* Tampilan saat Loading */
          <div className="rounded-xl border border-border dark:border-zinc-800 bg-card overflow-hidden shadow-sm">
            <SkeletonTable />
          </div>
        ) : isError ? (
          /* Tampilan saat Error */
          <div className="flex flex-col items-center justify-center h-[400px] rounded-xl border border-destructive/20 bg-destructive/5 dark:bg-destructive/10 text-destructive dark:text-red-400 shadow-sm">
            <AlertCircle className="h-10 w-10 mb-3 opacity-80" />
            <h3 className="text-lg font-semibold">Gagal Memuat Data</h3>
            <p className="text-sm opacity-80 max-w-xs text-center">
              Terjadi kesalahan pada server atau jaringan Anda. Silakan coba
              beberapa saat lagi.
            </p>
          </div>
        ) : (
          /* Tampilan saat Berhasil Memuat Data */
          <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
            <DataTable
              data={data?.data || []}
              paginationData={data}
              columns={columns}
            />
          </div>
        )}
      </div>
    </div>
  );
}
